var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDown';
import { TextButton, TextButtonPriority } from '../TextButton';
import { DATA_HOOKS } from './constants';
import { st, classes } from './FloatingDropdownBase.st.css';
import classnames from 'classnames';
var FloatingDropdownBase = /** @class */ (function (_super) {
    __extends(FloatingDropdownBase, _super);
    function FloatingDropdownBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getSelectedOption = function (selectedId) {
            var options = _this.props.options;
            return options.find(function (_a) {
                var id = _a.id;
                return selectedId === id;
            });
        };
        _this._onSelect = function (e) {
            var onChange = _this.props.onChange;
            var selectedId = e.target.value;
            if (onChange) {
                onChange(_this._getSelectedOption(selectedId));
            }
        };
        return _this;
    }
    FloatingDropdownBase.prototype._getContent = function () {
        var _a = this.props, value = _a.value, placeholder = _a.placeholder, label = _a.label, options = _a.options, ariaLabelledBy = _a["aria-labelledby"], mobile = _a.mobile, disabled = _a.disabled, name = _a.name;
        var selectedOption = this._getSelectedOption(value);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.content },
                React.createElement("div", { className: classes.textContent },
                    React.createElement("span", { className: classes.label }, label),
                    React.createElement("div", { className: classes.selectedValue, "data-hook": DATA_HOOKS.baseSelectedValue }, (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || placeholder)),
                React.createElement(ChevronDown, { className: classes.arrowIcon })),
            mobile ? (React.createElement("select", { value: value, name: name, className: classes.select, "aria-labelledby": ariaLabelledBy, "data-hook": DATA_HOOKS.nativeSelect, onChange: this._onSelect, disabled: disabled },
                placeholder ? (React.createElement("option", { value: "", disabled: true }, placeholder)) : null,
                options.map(function (option) {
                    return !option.divider ? (React.createElement("option", { value: option.id, disabled: !option.isSelectable, key: option.id }, option.value)) : null;
                }))) : null));
    };
    FloatingDropdownBase.prototype.render = function () {
        var _a;
        var _b = this.props, ariaLabel = _b["aria-label"], ariaLabelledBy = _b["aria-labelledby"], ariaActivedescendant = _b["aria-activedescendant"], mobile = _b.mobile, id = _b.id, disabled = _b.disabled, className = _b.className, displayBlock = _b.displayBlock;
        var content = this._getContent();
        if (!mobile) {
            content = (React.createElement(TextButton, { "aria-haspopup": 'menu', "aria-expanded": this.props.isExpanded, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy || id, "aria-activedescendant": ariaActivedescendant, disabled: disabled, "data-hook": DATA_HOOKS.floatingDropdownButton, priority: TextButtonPriority.secondary, className: classes.btn }, content));
        }
        return (React.createElement("div", { className: st(classes.root, { mobile: mobile, disabled: disabled }, classnames(classes.overrideStyleParams, className, (_a = {},
                _a[classes.displayBlock] = displayBlock,
                _a))), "data-hook": DATA_HOOKS.base }, content));
    };
    return FloatingDropdownBase;
}(React.Component));
export { FloatingDropdownBase };
//# sourceMappingURL=FloatingDropdownBase.js.map